import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    // Full design-system palette for the dark redesign.
    // Every color used across Navbar.tsx / Home.tsx should reference
    // a token here (e.g. "rs.bg") rather than a raw hex string, so the
    // whole site can be re-themed from this one file.
    // theme.ts — LIGHT THEME
    rs: {
      bg: "#F7F5F2", // page background (warm off-white)
      bgAlt: "#EFEDE8", // alternating section background
      surface: "#FFFFFF", // card / panel background
      surfaceHover: "#FAFAF8", // card hover state
      surfaceRaised: "#FFFFFF", // popovers, menus, modals
      imageWell: "#FFFFFF", // product image background well (matches white product photos)

      border: "rgba(20,20,20,0.08)",
      borderStrong: "rgba(20,20,20,0.15)",

      text: "#1A1A1A",
      textMuted: "rgba(26,26,26,0.55)",
      textDim: "rgba(26,26,26,0.35)",

      red: "#C41230",
      redHover: "#a50f28",
      redActive: "#8e0c22",
      redLinkHover: "#e8193a",
      redAlpha: "rgba(196,18,48,0.08)",
      redBorder: "rgba(196,18,48,0.22)",

      skeletonStart: "#EFEDE8",
      skeletonEnd: "#E0DDD6",
      skeletonImageStart: "#FFFFFF",
      skeletonImageEnd: "#F0EEE9",
    },
    //DARK THEME
    // rs: {
    //   bg: "#141414", // page background
    //   bgAlt: "#181818", // alternating section background
    //   surface: "#1C1C1C", // card / panel background
    //   surfaceHover: "#212121", // card hover state
    //   surfaceRaised: "#242424", // popovers, menus, modals-on-dark
    //   imageWell: "#191919", // product image background well

    //   border: "rgba(255,255,255,0.07)",
    //   borderStrong: "rgba(255,255,255,0.13)",

    //   text: "#EDEBE6",
    //   textMuted: "rgba(237,235,230,0.45)",
    //   textDim: "rgba(237,235,230,0.25)",

    //   red: "#C41230",
    //   redHover: "#a50f28",
    //   redActive: "#8e0c22",
    //   redLinkHover: "#e8193a",
    //   redAlpha: "rgba(196,18,48,0.12)",
    //   redBorder: "rgba(196,18,48,0.22)",

    //   skeletonStart: "#1C1C1C",
    //   skeletonEnd: "#2A2A2A",
    //   skeletonImageStart: "#191919",
    //   skeletonImageEnd: "#252525",
    // },
  },
  fonts: {
    heading: `'DM Serif Display', Georgia, serif`,
    body: `'DM Sans', system-ui, sans-serif`,
  },
  styles: {
    global: {
      "@import": [
        "url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Serif+Display:ital@0;1&display=swap')",
      ],
      "html, body": {
        bg: "rs.bg",
        color: "rs.text",
        overflowX: "hidden",
      },
      "*": { boxSizing: "border-box" },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontFamily: "'DM Sans', sans-serif",
        fontWeight: "500",
        borderRadius: "6px",
        letterSpacing: "0.02em",
      },
      variants: {
        solid: {
          bg: "rs.red",
          color: "white",
          border: "1px solid",
          borderColor: "rs.red",
          _hover: { bg: "rs.redHover", borderColor: "rs.redHover" },
          _active: { bg: "rs.redActive" },
        },
        outline: {
          bg: "transparent",
          color: "rs.textMuted",
          border: "1px solid",
          borderColor: "rs.borderStrong",
          _hover: { bg: "rs.surface", color: "rs.text" },
        },
        ghost: {
          bg: "transparent",
          color: "rs.textMuted",
          _hover: { bg: "rs.surface", color: "rs.text" },
        },
      },
      defaultProps: { variant: "solid" },
    },
    Heading: {
      baseStyle: { color: "rs.text" },
    },
    Link: {
      baseStyle: {
        color: "rs.textMuted",
        _hover: { color: "rs.text", textDecoration: "none" },
      },
    },
    Popover: {
      parts: ["content", "arrow"],
      baseStyle: {
        content: {
          bg: "rs.surfaceRaised",
          border: "1px solid",
          borderColor: "rs.borderStrong",
          color: "rs.text",
          _focus: { outline: "none", boxShadow: "none" },
        },
        arrow: { bg: "rs.surfaceRaised" },
      },
    },
    Modal: {
      parts: ["overlay", "content"],
      baseStyle: {
        overlay: { bg: "blackAlpha.900" },
        content: { bg: "transparent", boxShadow: "none" },
      },
    },
    Skeleton: {
      baseStyle: {
        startColor: "rs.skeletonStart",
        endColor: "rs.skeletonEnd",
        borderRadius: "6px",
      },
    },
    Menu: {
      parts: ["list", "item"],
      baseStyle: {
        list: {
          bg: "rs.surface",
          border: "1px solid",
          borderColor: "rs.borderStrong",
          borderRadius: "8px",
          py: "6px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.6)",
        },
        item: {
          bg: "transparent",
          color: "rs.textMuted",
          fontSize: "13px",
          _hover: { bg: "rs.surfaceHover", color: "rs.text" },
          _focus: { bg: "rs.surfaceHover" },
        },
      },
    },
  },
});

export default theme;
